export const POST_UPLOAD_REQUEST = 'POST_UPLOAD_REQUEST';
export const POST_UPLOAD_SUCCESS = 'POST_UPLOAD_SUCCESS';
export const POST_UPLOAD_FAIL = 'POST_UPLOAD_FAIL';
export const POST_REMOVE = 'POST_REMOVE';

export const POST_FETCH_REQUEST = 'POST_FETCH_REQUEST';
export const POST_FETCH_SUCCESS = 'POST_FETCH_SUCCESS';
export const POST_FETCH_FAIL = 'POST_FETCH_FAIL';

export const POST_EDIT_REQUEST = 'POST_EDIT_REQUEST';
export const POST_EDIT_SUCCESS = 'POST_EDIT_SUCCESS';
export const POST_EDIT_FAIL = 'POST_EDIT_FAIL';

export const POST_DELETE_REQUEST = 'POST_DELETE_REQUEST';
export const POST_DELETE_SUCCESS = 'POST_DELETE_SUCCESS';
export const POST_DELETE_FAIL = 'POST_DELETE_FAIL';
